module.exports = __webpack_public_path__ + "static/media/11_crear_menu_plantilla_galeria_roja.e363b84f.png";